<template>
  <div>
    <div class="background-image-login" style="background-image: url(img/temp/cook.jpg)"></div>

    <!-- Header -->
    <div class="header py-8 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-4">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white" v-if="pageTitle">{{ pageTitle }}</h1>
              <p class="text-lead text-white" v-if="pageEntry">{{ pageEntry }}</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col xs="12" lg="6" v-for="video in videos" :key="video.index">
          <b-card class="card-video">
            <div class="card__video">
              <div class="card__video-player js-youtube-video" :data-video-id="video.youtube_video_id"></div><!-- /.card__video-player -->
            </div><!-- /.card__video -->

            <div class="card__content">
              <h3 v-if="video.title">{{ video.title }}</h3>

              <div v-html="video.text"></div>
            </div><!-- /.card__content -->
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

export default {
  data() {
    return {
      data: null
    };
  },
  computed: {
    pageTitle() {
      return this.data && this.data.pages.getting_started.title;
    },
    pageEntry() {
      return this.data && this.data.pages.getting_started.entry;
    },
    videos() {
      return this.data && this.data.tutorial_videos.items;
    }
  },
  methods: {
    youtubeIframe(url) {

    }
  },
  mounted() {
    document.querySelectorAll('.js-youtube-video').forEach(function(video) {
      let videoId = video.getAttribute('data-video-id');

      let player = new YT.Player(video, {
        videoId: videoId
      });
    });
  }
};
</script>
